export { makeRumPublicApi } from './boot/rumPublicApi';
export { startRum } from './boot/startRum';
export { LifeCycle } from './domain/lifeCycle';
export { getMutationObserverConstructor } from './browser/domMutationObservable';
export { initViewportObservable, getViewportDimension } from './browser/viewportObservable';
export { DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE } from './domain/rumEventsCollection/action/getActionNameFromElement';
export { STABLE_ATTRIBUTES } from './domain/rumEventsCollection/action/getSelectorFromElement';
//# sourceMappingURL=index.js.map